import UserWorkflowDetailCustomerView from './UserWorkflowDetailCustomerView';

export default UserWorkflowDetailCustomerView;